/* eslint-disable */
export enum TrainingRecordStatus {
  Scheduled = 1,
  Attended = 2,
  NoShow = 3,
  CancelledByVolunteer = 4,
  CancelledByStaff = 5,
}
